import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  TextField,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import "./MobileSign.scss";
import { useUser } from "../../common/contexts/userContext";
import { useNavigate } from "react-router-dom";
import { useFixtures } from "../../common/contexts/fixturesContext";
import { useBets } from "../../common/contexts/betContext";
import { login } from "../../services/authService";
import { getAllMatches } from "../../services/matchService";
import { getUserBets } from "../../services/betService";
import { setSession } from "../../services/authStorage";
import debounce from "debounce";

export const initialLoginValues: { username: string; password: string } = {
  username: "",
  password: "",
};

export const MobileLoginPanel = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loginValues, setLoginValues] = useState(initialLoginValues);
  const { setUser } = useUser();
  const { setMatches } = useFixtures();
  const { setBets } = useBets();
  const navigate = useNavigate();
  const handleClickShowPassword = () =>
    setShowPassword((show: boolean) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  function handleChangeEmail(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    setLoginValues((prev) => ({ ...prev, username: e.target.value }));
  }

  function handleChangePassword(e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    setLoginValues((prev) => ({ ...prev, password: e.target.value }));
  }

  async function handleLogin() {
    try {
      const data = await login({ username: loginValues.username, password: loginValues.password });
      if (!data.isSucceed) {
        alert("Incorrect credentials");
        return;
      }
      setSession(data.data.accessToken);
      setUser(data.data.user);
      const [matches, bets] = await Promise.all([
        getAllMatches(),
        getUserBets(data.data.user.id),
      ]);
      setMatches(matches.filter((match) => match.homeTeam && match.awayTeam));
      setBets(bets);
      navigate("/profile");
    } catch {
      alert("Wrong credentials.");
    }
  }

  return (
    <Box display="flex" flexDirection="column" gap="15px">
      <div className="mobileLogin__title">Welcome back</div>
      <Typography> Username </Typography>

      <TextField
        variant="outlined"
        InputProps={{ className: "customedInput borderRadiusInput" }}
        type="text"
        value={loginValues.username}
        onChange={handleChangeEmail}
        name="email"
      />
      <Typography> Password </Typography>
      <OutlinedInput
        id="outlined-adornment-password"
        type={showPassword ? "text" : "password"}
        onChange={handleChangePassword}
        value={loginValues.password}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        className="customedInput outlinedCustomInput"
        name="password"
      />
      {/* <Link
        style={{
          textAlign: "end",
          margin: 0,
          color: "var(--link)",
          textDecoration: "none",
        }}
      >
        Forgot password?
      </Link> */}
      <Button
        className="mobileLogin__submit"
        onClick={debounce(handleLogin, 600)}
      >
        Log In
      </Button>
    </Box>
  );
};
